import React, { useId, useState } from 'react';
import { useIntl } from 'react-intl';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
import messages from '../../../locale/jsonMessages';
import s from './OwnerReporting.css';

// "i" button with a plain-language explanation. Works with hover, keyboard focus and tap (toggle); Escape hides it.
// Never put it INSIDE another <button>: render it next to the button (a nested button is invalid and its click would act on the parent).
const InfoTooltip = ({ text }) => {
  const { formatMessage } = useIntl();
  const tipId = useId();
  const [open, setOpen] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  if (!text) return null;
  return (
    <span className={s.infoWrap} onMouseLeave={() => setDismissed(false)}>
      <button type="button" className={s.infoButton} aria-label={formatMessage(messages.orpMoreInfo)} aria-expanded={open}
        aria-describedby={tipId}
        onClick={(event) => { event.stopPropagation(); setDismissed(false); setOpen((value) => !value); }}
        onKeyDown={(event) => { if (event.key === 'Escape') { setOpen(false); setDismissed(true); } }}
        onBlur={() => { setOpen(false); setDismissed(false); }}>i</button>
      <span id={tipId} role="tooltip" className={cx(s.infoTip, open && s.infoTipOpen, dismissed && s.infoTipDismissed)}>{text}</span>
    </span>
  );
};

export default withStyles(s)(InfoTooltip);
